import React from 'react';
import { Col, Button, Space } from 'antd';
import { COLORS, STRINGS } from '../utils/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const fontStyle = { color: '#BD9806', fontFamily: 'OpenSans-Bold', fontSize: 13, lineHeight: 1 };

const LoginMobile = (props) => {
    return (
        <div className="AppLogin" style={{ display: 'flex' }}>
            <div>
            <div onClick={() => { props.setVisibility(true); }} style={{ position: 'absolute', zIndex: 1,
            cursor: 'pointer', display: 'flex', flexDirection: 'row', right: 20, top: 30 }}>
                <FontAwesomeIcon icon={faUser} style={{ fontSize: 20, color: COLORS.yellow }} />
            </div>
            <div style={{ position: 'absolute', width: '100%', height: '50%', marginTop: 120 }}>
              <img src={require('../images/appleTv.png')} alt='HIT' className='MobileTvLogo' /> 
            </div>
            <div style={{ background: COLORS.blue2a3a4a }}>
                <Col span={18} offset={3} style={{ width: '100%' }}>
                    <img src={require('../images/logo2.png')} alt='HIT' className='MobileLogo' /> 
                    <div style={{ display:'flex' }}>
                        <Space style={{ alignContent:'center', width:'100%' }} direction='vertical'>
                            <div style={{ display:'flex', justifyContent: 'center', height: 200 }}>
                                    <h2 className='Agree' style={{ textShadow:'2px 5px 5px #1a2a3a', whiteSpace:'break-spaces', 
                                    lineHeight: 1, fontSize: 50, fontWeight: 700, fontFamily: 'OpenSans-Bold', alignSelf:'center', 
                                    textAlign:'center', color: COLORS.yellowLight, marginBottom: 0, zIndex: 8 }}>
                                        {'THEATRE\nIN A BOX'}
                                    </h2>
                            </div>                     
                            <h3 style={{ fontSize: 24, fontFamily: 'OpenSans-Bold', color: COLORS.yellowLight, 
                            marginTop: 60, marginBottom: 8, lineHeight: 0 }}>
                                MADE FOR
                            </h3>
                            <div style={{ display: 'grid', justifyContent:'center' }}>
                              <h3 style={fontStyle} className="landingButton" type="link">Mini Theatres</h3>
                              <h3 style={fontStyle} className="landingButton" type="link">Social Theatres</h3>
                              <h3 style={fontStyle} className="landingButton" type="link">Gated Communities</h3>
                              <h3 style={fontStyle} className="landingButton" type="link">Private Theatres</h3>
                            </div>
                            <p className="Agree" style={{ fontSize: 14, fontFamily: 'OpenSans-SemiBold',
                            whiteSpace:'break-spaces', marginTop: 20, color: COLORS.lightBlue, lineHeight: 1.4 }}>
                            {STRINGS.securityStr}
                            </p>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: 30 }}>
                              <a href={STRINGS.aboutUrl} rel="noopener noreferrer" target="_blank">
                                  <Button style={{ fontFamily: 'OpenSans-Bold', fontSize: 20 }} className="landingButton" type="link">How</Button>
                              </a>
                              <a href={STRINGS.whyUrl} rel="noopener noreferrer" target="_blank">
                                  <Button style={{ fontFamily: 'OpenSans-Bold', fontSize: 20 }} className="landingButton" type="link">Why</Button>
                              </a>
                            </div>
                        </Space>
                    </div>
                </Col>
            <div style={{ display: 'flex', width: '100%', backgroundColor: '#0A1A2A' }}>
                <Col span={20} offset={2} style={{ width: '100%', borderRadius: 15, backgroundColor: '#0A1A2A', marginTop: 30, paddingLeft: 12, paddingRight: 12 }}>
                      <img src={require('../images/footerLogoMobile.png')} alt='Supported Devices' 
                      className='MobileFooter' />
                    <p className="Agree" style={{ paddingTop: 40, fontSize: 12, fontFamily: 'OpenSans-SemiBold', color: COLORS.lightBlue, lineHeight: 1.2 }}>
                      {STRINGS.bankAccountStr}<a style={{ color: COLORS.blue5a6a7a, textDecoration:'underline' }} href={STRINGS.termsUrl} rel="noopener noreferrer" target='_blank'>here.</a>
                    </p>
                    <p className="Agree" style={{ paddingTop: 10, fontSize: 12, fontFamily: 'OpenSans-SemiBold', color: COLORS.lightBlue, lineHeight: 1.2 }}>
                      {STRINGS.contriesList}
                    </p>
                    <div style={{ display: 'grid', justifyContent:'center' }}>
                        <a href={STRINGS.aboutUrl} rel="noopener noreferrer" target="_blank">
                          <Button style={{ fontFamily: 'OpenSans-SemiBold', fontSize: 13 }} className="landingButton" type="link">About</Button>
                        </a>
                        <a href={STRINGS.termsUrl} rel="noopener noreferrer" target="_blank">
                          <Button style={{ fontFamily: 'OpenSans-SemiBold', fontSize: 13 }} className="landingButton" type="link">Services & Privacy Terms</Button>
                        </a>
                        <a href={STRINGS.statusUrl} rel="noopener noreferrer" target="_blank">
                          <Button style={{ fontFamily: 'OpenSans-SemiBold', fontSize: 13 }} className="landingButton" type="link">Status</Button>
                        </a>
                        <a href={STRINGS.contactUrl} rel="noopener noreferrer" target="_blank">
                          <Button style={{ fontFamily: 'OpenSans-SemiBold', fontSize: 13 }} className="landingButton" type="link">Contact</Button>
                        </a>
                    </div>
                    <div style={{ height: 20 }}/>
                    <a href='https://twitter.com/MyHitMovie' target='_blank' rel='noopener noreferrer' className='twitterIcon'>
                    <FontAwesomeIcon icon={faTwitter} />
                    </a>
                    <div style={{ height: 20 }}/>
                </Col>
            </div>
            </div> 
            </div> 
        </div>
    );
}

export default LoginMobile;